import type { ConnectionEditState } from "../../viewmodels/board/connections/Connections.types";
import { parseConnectionConfiguration } from "../source-settings/SourceSettingsConfiguration";

interface JiraStatusReference {
  id?: unknown;
}

interface JiraConfigurationValidationModel {
  doneStatus?: JiraStatusReference;
  statusesToLoad?: JiraStatusReference[];
}

const normalizeId = (value: unknown): string => String(value ?? "");

export const getJiraSourceSettingsValidationMessage = (
  editingConnection: ConnectionEditState,
  t: (key: string) => string,
): string => {
  const configuration =
    parseConnectionConfiguration<JiraConfigurationValidationModel>(
      editingConnection.configuration,
    );
  const doneStatusId = normalizeId(configuration.doneStatus?.id);

  if (!doneStatusId) {
    return "";
  }

  const statusesToLoad = configuration.statusesToLoad ?? [];
  return statusesToLoad.some(
    (status) => normalizeId(status.id) === doneStatusId,
  )
    ? t("board.connections.dialog.sourceSettings.jira.statusReferenceError")
    : "";
};
